import { Col, Row, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import FormCheckBox from '../../../../../components/Inputs/FormCheckBox';
import FormLabel from '../../../../../components/Labels/FormLabel';
import SecondaryLabel from '../../../../../components/Labels/SecondaryLabel';

const ProvidersListCard = ({
  providerDetails: { carrierName, tenderEmailAddress },
  index,
  handleProviderClick,
  selected,
  isLastItem,
}) => {
  const tenderEmailAddressFormated = tenderEmailAddress?.replaceAll(';', ', ');
  const [expand, setExpand] = useState(false);
  const [render, setRender] = useState(0);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleOpen = () => {
    setExpand(!expand);
    if (expand) {
      setRender(render + 1);
    }
  };
  return (
    <Row
      gutter={15}
      align="middle"
      className={`${!isLastItem && 'border-bottom-muted'} px-16 py-10`}
      key={render}
      wrap={false}
    >
      <Col sm={11}>
        <FormCheckBox
          checkBoxClass="normal-checkbox align-items-center"
          className="m-0 "
          onChange={(e) => handleProviderClick(e, index)}
          checked={selected}
          label={
            <>
              <FormLabel>{t('translation:default.fields.transportationProvider.label')}</FormLabel> <br />
              <SecondaryLabel className="fw-600 text-dark f-14">{carrierName}</SecondaryLabel>
            </>
          }
        />
      </Col>
      <Col sm={13}>
        <FormLabel>{t('translation:default.fields.tenderEmailAddress')}</FormLabel> <br />
        <Typography.Paragraph
          className="m-0 fw-600 w-100 text-dark f-14"
          ellipsis={{
            rows: 1,
            expandable: true,
            onExpand: handleOpen,
          }}
        >
          {tenderEmailAddressFormated}
          {expand && (
            // biome-ignore lint/a11y/useValidAnchor: <explanation>
            <a className="ml-5" onClick={handleOpen}>
              {t('translation:default.buttons.close')}
            </a>
          )}
        </Typography.Paragraph>
      </Col>
    </Row>
  );
};

export default ProvidersListCard;
